import { translate as t } from '@thoughtspot/i18n';
import { jsonConstants } from '@thoughtspot/json-constants';
import { getAdminPrivilegeSegregation, hasCreateSpotAppPrivilege, hasDataCatalogEnabled, hasVerifyLiveboardPrivilegeEnabled, isA3Enabled, isAgentSpotEnabled, isAnalystStudioEnabled, isAnswerV2Enabled, isBypassRLSPrivilegeEnabled, isCollectionsPrivilegeEnabled, isDocumentSearchEnabled, isFoldersEnabled, isNebulaDevCluster, isOrgUiEnabled, isPinboardCreationPrivilegeEnabled, isRolesEnabled, isSaaSCluster, isSchedulingJobEnabled, isThirdPartyAnalysisEnabled, isWriteBackEnabled, shouldDisplayAIControls, } from '@thoughtspot/session-service';
import { isOktaEnabled } from '@thoughtspot/system-config-service';
import _ from 'lodash';
let exposedGroupPrivileges;
export const defaultGroupPrivileges = [
    jsonConstants.privilegeType.USERDATAUPLOADING,
    jsonConstants.privilegeType.DATADOWNLOADING,
];
const ADMIN_PRIVILEGES_LIST = [
    {
        id: jsonConstants.privilegeType.APPLICATION_ADMINISTRATION,
        name: t('privilegesLabels.APPLICATION_ADMINISTRATION'),
    },
    {
        id: jsonConstants.privilegeType.USER_ADMINISTRATION,
        name: t('privilegesLabels.USER_ADMINISTRATION'),
    },
    {
        id: jsonConstants.privilegeType.GROUP_ADMINISTRATION,
        name: t('privilegesLabels.GROUP_ADMINISTRATION'),
    },
    {
        id: jsonConstants.privilegeType.BACKUP_ADMINISTRATION,
        name: t('privilegesLabels.BACKUP_ADMINISTRATION'),
    },
    {
        id: jsonConstants.privilegeType.SYSTEM_INFO_ADMINISTRATION,
        name: t('privilegesLabels.SYSTEM_INFO_ADMINISTRATION'),
    },
];
const isAdministrationPrivilege = () => {
    return getAdminPrivilegeSegregation();
};
const initExposedGroupPrivileges = () => {
    exposedGroupPrivileges = [];
    exposedGroupPrivileges.push(...[
        {
            id: jsonConstants.privilegeType.USERDATAUPLOADING,
            name: t('privilegesLabels.USERDATAUPLOADING'),
        },
        {
            id: jsonConstants.privilegeType.DATADOWNLOADING,
            name: t('privilegesLabels.DATADOWNLOADING'),
        },
        {
            id: jsonConstants.privilegeType.DEVELOPER,
            name: t('privilegesLabels.DEVELOPER'),
        },
        {
            id: jsonConstants.privilegeType.SHAREWITHALL,
            name: t('privilegesLabels.SHAREWITHALL'),
        },
        {
            id: jsonConstants.privilegeType.EXPERIMENTALFEATUREPRIVILEGE,
            name: t('privilegesLabels.EXPERIMENTALFEATUREPRIVILEGE'),
        },
        {
            id: jsonConstants.privilegeType.CAN_MANAGE_VERSION_CONTROL,
            name: t('privilegesLabels.CAN_MANAGE_VERSION_CONTROL'),
        },
    ]);
    if (isSaaSCluster() || isNebulaDevCluster() || shouldDisplayAIControls()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_USE_SPOTTER,
            name: t('privilegesLabels.CAN_USE_SPOTTER'),
        });
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_MANAGE_SPOTTER,
            name: t('privilegesLabels.CAN_MANAGE_SPOTTER'),
        });
    }
    if (isSaaSCluster() || isNebulaDevCluster()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.SYNCMANAGEMENT,
            name: t('privilegesLabels.SYNCMANAGEMENT'),
        });
    }
    if (!isRolesEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.DATAMANAGEMENT,
            name: t('privilegesLabels.DATAMANAGEMENT'),
        });
    }
    if (isDocumentSearchEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_PREVIEW_DOC_SEARCH,
            name: t('privilegesLabels.CAN_PREVIEW_DOC_SEARCH'),
        });
    }
    if (hasCreateSpotAppPrivilege()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.ENABLESPOTAPPCREATION,
            name: t('privilegesLabels.ENABLESPOTAPPCREATION'),
        });
    }
    if (hasDataCatalogEnabled() && (isSaaSCluster() || isNebulaDevCluster())) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_CREATE_CATALOG,
            name: t('privilegesLabels.CAN_CREATE_CATALOG'),
        });
    }
    if (!isSaaSCluster()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.RANALYSIS,
            name: t('privilegesLabels.RANALYSIS'),
        });
    }
    if (isSchedulingJobEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.JOBSCHEDULING,
            name: t('privilegesLabels.JOBSCHEDULING'),
        });
    }
    if (isA3Enabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.A3ANALYSIS,
            name: t('privilegesLabels.A3ANALYSIS'),
        });
        if (isThirdPartyAnalysisEnabled()) {
            exposedGroupPrivileges.push({
                id: jsonConstants.privilegeType.THIRDPARTY_ANALYSIS,
                name: t('privilegesLabels.THIRDPARTY_ANALYSIS'),
            });
        }
    }
    if (isBypassRLSPrivilegeEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.BYPASSRLS,
            name: t('privilegesLabels.BYPASSRLS'),
            hasWarningMessageToShow: true,
            warningTitle: t('WARNING'),
            warningDescription: t('ADMIN_RLS_WARNING'),
        });
    }
    if (isPinboardCreationPrivilegeEnabled() && !isAnswerV2Enabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.DISABLE_PINBOARD_CREATION,
            name: t('privilegesLabels.DISABLE_PINBOARD_CREATION'),
        });
    }
    if (!isAdministrationPrivilege()) {
        exposedGroupPrivileges.unshift({
            id: jsonConstants.privilegeType.ADMINISTRATION,
            name: isOrgUiEnabled()
                ? t('privilegesLabels.ORG_ADMINISTRATION')
                : t('privilegesLabels.ADMINISTRATION'),
        });
    }
    else if (isAdministrationPrivilege()) {
        exposedGroupPrivileges.push(...ADMIN_PRIVILEGES_LIST);
    }
    if (hasVerifyLiveboardPrivilegeEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.LIVEBOARD_VERIFIER,
            name: t('privilegesLabels.LIVEBOARD_VERIFIER'),
        });
    }
    if (isOktaEnabled() && isAnalystStudioEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_MANAGE_ANALYST_STUDIO,
            name: t('privilegesLabels.CAN_MANAGE_ANALYST_STUDIO'),
        });
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_ACCESS_ANALYST_STUDIO,
            name: t('privilegesLabels.CAN_ACCESS_ANALYST_STUDIO'),
        });
    }
    if (isFoldersEnabled() && isCollectionsPrivilegeEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_VIEW_FOLDERS,
            name: t('privilegesLabels.CAN_VIEW_FOLDERS'),
        });
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_MODIFY_FOLDERS,
            name: t('privilegesLabels.CAN_MODIFY_FOLDERS'),
        });
    }
    if (isAgentSpotEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_MANAGE_AGENTSPOT,
            name: t('privilegesLabels.CAN_MANAGE_AGENTSPOT'),
        });
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_ACCESS_AGENTSPOT,
            name: t('privilegesLabels.CAN_ACCESS_AGENTSPOT'),
        });
    }
    if (isWriteBackEnabled()) {
        exposedGroupPrivileges.push({
            id: jsonConstants.privilegeType.CAN_MANAGE_INPUT_TABLES,
            name: t('privilegesLabels.CAN_MANAGE_INPUT_TABLES'),
        });
    }
};
const isAdminPrivilegeOption = () => {
    const isAdminAvailable = exposedGroupPrivileges.some(item => {
        return item.id === jsonConstants.privilegeType.ADMINISTRATION;
    });
    return isAdminAvailable;
};
export const getExposedGroupPrivileges = (privilegeItems) => {
    if (!exposedGroupPrivileges) {
        initExposedGroupPrivileges();
    }
    if (isAdministrationPrivilege()) {
        if (privilegeItems) {
            if (privilegeItems.some(item => item === jsonConstants.privilegeType.ADMINISTRATION)) {
                const adminPrivilege = {
                    id: jsonConstants.privilegeType.ADMINISTRATION,
                    name: t('privilegesLabels.ADMINISTRATION'),
                    isReadOnly: true,
                };
                if (!isAdminPrivilegeOption()) {
                    exposedGroupPrivileges.unshift(adminPrivilege);
                }
                else {
                    exposedGroupPrivileges[0] = adminPrivilege;
                }
            }
            else if (isAdminPrivilegeOption()) {
                exposedGroupPrivileges.shift();
            }
        }
        else if (isAdminPrivilegeOption()) {
            exposedGroupPrivileges.shift();
        }
    }
    return _.clone(exposedGroupPrivileges);
};
//# sourceMappingURL=groups-privileges.util.js.map